import React from "react"
import { MenuItem, Select } from "@mui/material"

const PEPackagingLineSelect = ({ onChange, value, name, options = [] }) => {
  return (
    <Select
      name={name}
      value={value}
      onChange={onChange}
      variant="standard"
      sx={{ width: "100%", fontSize: "14px" }}
    >
      {options.map(option => (
        <MenuItem key={option.value} value={option.value} sx={{ fontSize: "14px"}}>
          {option.label}
        </MenuItem>
      ))}
    </Select>
  )
}

export default PEPackagingLineSelect 